import * as log from "loglevel";
import * as React from "react";

import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { Button, Form, Header, Icon } from "semantic-ui-react";
import { UserStore } from "../../stores/user-store";


declare var toastr: any;

interface IMobileWarningProps {
	userStore?: UserStore;
}

interface IMobileWarningState {

}

@inject("userStore") @observer
export class MobileWarning extends React.Component<IMobileWarningProps, IMobileWarningState>{
	constructor(props, state) {
		super(props, state);
		this.state = {};
		this.handleDismiss = this.handleDismiss.bind(this);
	}

	handleDismiss() {
		this.props.userStore.setMobileWarning(true);
	}

	render() {
		return (
			<div style={{ "position": "fixed", "left": 0, "right": 0, "top": 0, "bottom": 0, "zIndex": 1000, "background": "white" }}>
				<div style={{ "position": "absolute", "margin": "0", "top": "100px", "left": "50%", "transform": "translate(-50%, 0%)" }}>
					<img src="//cdn.jibunu.com/images/jibunu6.png" />
					<Header size="huge" as="h1" >
						JUMP isn't optimized for mobile yet<br /><br />We recommend the desktop site for the best experience
					</Header>
					<Button icon size="massive" className="jibunu-blue" onClick={this.handleDismiss}>
						<Icon name="close" />
						Dismiss
					</Button>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/common/mobile-warning.tsx